import { ReactNode } from 'react';
import { Link } from 'react-router-dom';

interface AnchorProps {
  to: string;
  children: ReactNode;
}

const Anchor: React.FC<AnchorProps> = ({ to, children }) => {
  const isInSiteLink = to.startsWith(import.meta.env.BASE_URL);

  if (isInSiteLink) {
    return <Link to={to}>{children}</Link>;
  }
  return (
    <a href={to} target="_blank">
      {children}
    </a>
  );
};

export default Anchor;
